import { render } from "./phoneVerification.vue?vue&type=template&id=532de341&scoped=true"
import script from "./phoneVerification.vue?vue&type=script&lang=js"
export * from "./phoneVerification.vue?vue&type=script&lang=js"

import "./phoneVerification.vue?vue&type=style&index=0&id=532de341&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532de341"]])

export default __exports__